<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 dialog-heading">Discounts</h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center"
        (click)="this._matDialogRef.close()">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div class="discount_wrapper max-h-96 min-h-96 flex flex-col gap-4">
        <ng-container *ngFor="let item of _data.discountList">

            <div class="discount_item flex rounded-e-3xl overflow-hidden items-stretch md:min-h-[103px] sm:min-h-[126px] sm:h-[126px] h-[126px] md:h-[103px]"
                matRipple>
                <div class="discount_child px-6 py-3 flex relative justify-center flex-col items-center"
                    [ngStyle]="dynamicStyle(item.color)">
                    <span
                        class="text-white-color md:text-3xl sm:text-2xl text-2xl font-Inter-SemiBold font-bold">{{item.discountAmt}}
                        %</span>
                    <span class="uppercase md:text-xl sm:text-lg text-lg text-white-color font-semibold">Discount</span>

                    <div
                        class="absolute w-[12%] aspect-square rounded-full bg-white-color top-[5px] left-[-10px] z-10 content-['']">
                    </div>
                    <div
                        class="absolute w-[12%] aspect-square rounded-full bg-white-color top-[30px] left-[-10px] z-10 content-['']">
                    </div>
                    <div
                        class="absolute w-[12%] aspect-square rounded-full bg-white-color top-[55px] left-[-10px] z-10 content-['']">
                    </div>
                    <div
                        class="absolute w-[12%] aspect-square rounded-full bg-white-color top-[80px] left-[-10px] z-10 content-['']">
                    </div>
                    <div
                        class="md:hidden sm:block block absolute w-[12%] aspect-square rounded-full bg-white-color top-[105px] left-[-10px] z-10 content-['']">
                    </div>

                </div>
                <div class="flex-auto px-5 justify-center bg-dark-cement-color py-4 flex flex-col gap-2">
                    <h6 class="text-blue-theme-color md:text-2xl sm:text-xl text-xl font-semibold">{{item.discountName}}
                    </h6>
                    <p class="md:text-xl sm:text-lg text-lg text-blue-theme-color font-normal">{{item.dayName}}
                        {{item.startTime}} to {{item.endTime}}</p>
                </div>
            </div>

        </ng-container>
    </div>
</mat-dialog-content>